export default __webpack_public_path__ + "static/media/logo_gold.e6e6dc03.svg";